const ApplicationStatus = {
  Pending: 'PENDING',
  Accepted: 'ACCEPTED',
  Declined: 'DECLINED',
}

Object.freeze(ApplicationStatus)

export { ApplicationStatus }
